module.exports = __webpack_public_path__ + "static/media/container4.54a5c7b2.jpg";